<template>
	<v-card class="mt-5 mr-5" width="300" height="400">
		<v-img
			cover
			width="300"
			:aspect-ratio="1"
			:src="process.env.VUE_APP_BACKEND_URL + '/plane/picture/' + _id"
		></v-img>
		<v-card-title>{{ registration }}</v-card-title>
		<v-card-text> {{ type }}</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: {
		registration: String,
		picture: String,
		type: String,
		_id: String,
	},
};
</script>
